<template>
  <div class="box pdf-view">
    <!-- <v-row class="mb-4 mx-0" dense justify="space-between">
      <h3 class="mb-0" style="flex-grow: 1">เอกสาร</h3>
    </v-row> -->

    <!-- <embed :src="url" type="application/pdf" width="100%" height="100%" /> -->

    <div class="customToolBar">
      <v-row justify="center" align="center" class="pt-2">
        <v-btn
          title="Back"
          class="white--text mr-2"
          style="background: #313131"
          icon
          @click="previousPage()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-text-field
          type="number"
          hide-details
          :max="pageCount"
          :min="1"
          v-model="showingPageNumber"
          @change="changePage()"
          @click="changePage()"
          class="customPageNumber"
        />
        <div class="pr-2"></div>
        /
        <div class="pr-2"></div>
        {{ this.pageCount }}
        <v-btn
          title="Next"
          :color="$buttonColor"
          class="white--text mr-1 ml-2"
          style="background: #313131"
          @click="nextPage()"
          icon
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
      <div class="customDivider"></div>
      <v-row>
        <v-col cols="auto">
          <div class="customLeftToolbar">
            <v-btn
              title="Undo"
              class="white--text mr-1"
              icon
              @click="undoDrawing()"
              style="background: #313131"
            >
              <v-icon>mdi-undo</v-icon>
            </v-btn>
            <v-btn
              title="Pen"
              class="white--text mr-1"
              icon
              @click="usePen()"
              style="background: #313131"
            >
              <v-icon :color="'#' + penLineColor">mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              title="Marker"
              class="white--text mr-1"
              @click="useMarker()"
              style="background: #313131"
              icon
            >
              <v-icon :color="'#' + markerLineColor">mdi-grease-pencil</v-icon>
            </v-btn>
            <v-btn
              title="Eraser"
              class="white--text mr-1"
              @click="useEraser()"
              style="background: #313131"
              icon
            >
              <v-icon>mdi-eraser</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <div class="customRightToolbar">
            <v-btn
              title="Download"
              v-if="isDownload"
              class="white--text mr-1"
              @click="download()"
              style="background: #313131"
              icon
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn
              title="Sync drawing to server"
              class="white--text mr-1"
              :disabled="savingPdfDrawing"
              @click="saveDrawing()"
              style="background: #313131"
              icon
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    
      <div
        v-show="loadingShowPDF"
        style="text-align: center; width: 100%; height:200px; background: #313131;"
      >
      <v-progress-circular
          :rotate="-90"
          :size="100"
          :width="15"
          :value="showPDFLoadingValue*2"
          color="white"
        >
          {{ showPDFLoadingValue }}
        </v-progress-circular>
      </div>

    <div style="position: relative" ref="pdfContrainer">
      <pdf
        v-show="!loadingShowPDF"
        :src="url"
        :page="page"
        @num-pages="pageCount = $event"
        @page-loaded="drawPDFNote()"
        @progress="loadedRatio = $event"
        @loaded="fetchDrawing()"
        style="border: 1px solid #e0e0e0; position: absolute; width: 100%"
        id="myCanvasCard"
        ref="pdfArea"
      >
      </pdf>

      <canvas
        id="myCanvas"
        ref="drawingArea"
        v-show="!loadingPdfDrawing"
        @mousedown="beginLine"
        @mousemove="drawLine"
        @mouseup="endLine"
        :v-touch="{ move: drawLine, start: beginLine, end: endLine }"
        :style="{ position: 'absolute' }"
      >
      </canvas>

      <div
        v-show="showPenMarkerOption"
        :style="{
          position: 'absolute',
          'background-color': '#FFFFFF',
          left: toolOptionLeft + 'px',
        }"
      >
        <v-card class="pa-2">
          <div class="customDivOneLine">
            <div
              v-for="item in colorList"
              :key="item"
              :style="{ background: '#' + item }"
              class="colorPicker ml-1"
              @click="changeColor(item)"
            />
          </div>
          <div class="customDividerOption"></div>
          <div class="customDivOneLine pt-3">
            <div
              v-for="item in sizeList"
              :key="item"
              :style="{ border: item + 'px solid #FFFFFF' }"
              class="sizePicker ml-1"
              @click="changeSize(item)"
            />
          </div>
        </v-card>
      </div>
    </div>

    <!-- <div id="area"></div> -->
  </div>
</template>
<script>
import axios from "axios";
import pdf from "vue-pdf";
import { mapState } from "vuex";

export default {
  props: ["url", "isDownload", "fileID"],
  components: {
    pdf,
  },
  computed: {
    ...mapState({
      pdfDrawing: (state) => state.pdfDrawing,
      savingPdfDrawing: (state) => state.savingPdfDrawing,
      loadingPdfDrawing: (state) => state.lavingPdfDrawing,
    }),
  },
  watch: {
    pdfDrawing: function (val) {
      this.drawPDFNote();
    },
    page: function (val) {
      this.showingPageNumber = this.page;
    },
    loadedRatio: function (val) {
      if (val != 1){
        this.loadingShowPDF = true;
        this.showPDFLoadingValue = Math.floor(val * 100);
        console.log("Loading PDF")
      }else{
        console.log("Done Loading PDF")
        this.showPDFLoadingValue = Math.floor(val * 100);
        this.page = 1;
        this.loadingShowPDF = false;
      }
    }
  },
  data: function () {
    return {
      loading: false, //Download PDF
      loadingShowPDF: false,
      pageCount: 0,
      page: 1,
      drawing: false,
      ctx: null,
      newLayer: {},
      percentOffsetRadio: 1,
      penStrokeWidth: 1,
      penLineColor: "000000",
      markerStrokeWidth: 16,
      markerLineColor: "FFFF00",
      resizeObserver: null,
      usingTool: 0, //0=pen 1=marker 2=eraser
      showingPageNumber: 1,
      colorList: [
        "FFFFFF",
        "000000",
        "FF0000",
        "FFFF00",
        "0000FF",
        "FF8040",
        "804000",
        "00FF00",
        "008000",
      ],
      sizeList: [14, 12, 10, 8, 6, 4, 2, 1, 0],
      eraserPosition: [],
      lineIndex: [],
      showPenMarkerOption: false,
      toolOptionLeft: 0,
      loadedRatio: 0,
      showPDFLoadingValue: 0
    };
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
    delete this.resizeObserver;
  },
  mounted() {
    //this.$store.dispatch("fetchDrawing", {fileID: this.fileID, userID: this.userID});
    // const book = ePub(this.url);
    // const rendition = book.renderTo("area", { width: 600, height: 400 });
    // const displayed = rendition.display();
    //this.resizeObserver = new ResizeObserver(this.onPdfResize).observe(this.$refs.pdfContrainer)
    //this.isDownload = true; // show download button
    //this.fetchDrawing();
  },
  methods: {
    async download() {
      this.showPenMarkerOption = false;
      this.loading = true;
      const fileName = this.url.replace(/\?.*$/, "").replace(/.*\//, "");

      await axios
        .get(this.url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(a.href);
        })
        .catch(console.error);

      this.loading = false;
    },
    fetchDrawing() {
      this.$store.dispatch("fetchDrawing", {
        fileID: this.fileID,
        userID: this.$userInfo._id,
      });
    },
    drawPDFNote() {
      var myCanvasCard = document.getElementById("myCanvasCard");
      var myCanvas = document.getElementById("myCanvas");

      this.ctx = myCanvas.getContext("2d");
      this.ctx.canvas.width = myCanvasCard.offsetWidth;
      this.ctx.canvas.height = myCanvasCard.offsetHeight;
      var offset = myCanvasCard.offsetWidth / 100;

      this.percentOffsetRadio = 100 / myCanvasCard.offsetWidth;

      if (this.pdfDrawing != null) {
        if (this.pdfDrawing.pages[this.page] === undefined) {
          this.pdfDrawing.pages[this.page] = { layers: [] };
        }

        for (
          var i = 0;
          i < this.pdfDrawing.pages[this.page].layers.length;
          i++
        ) {
          if (this.pdfDrawing.pages[this.page].layers[i] != undefined) {
            this.ctx.beginPath();

            var type;
            if (
              this.pdfDrawing.pages[this.page].layers[i].type ==
              "PDFToolType.pen"
            ) {
              type = 0;
            } else {
              type = 1;
            }

            this.ctx.strokeStyle = this.toColor(
              this.pdfDrawing.pages[this.page].layers[i].color,
              type
            );
            this.ctx.lineWidth =
              this.pdfDrawing.pages[this.page].layers[i].strokeWidthPercent *
              offset;

            for (
              var j = 0;
              j <
              this.pdfDrawing.pages[this.page].layers[i].percentOffsets.length;
              j++
            ) {
              var point = this.pdfDrawing.pages[this.page].layers[
                i
              ].percentOffsets[j].split(",");
              if (j == 0) {
                this.ctx.moveTo(point[0] * offset, point[1] * offset);
              } else {
                this.ctx.lineTo(point[0] * offset, point[1] * offset);
              }
              this.ctx.stroke();
            }
          }
        }
      }
    },
    toColor(num, type) {
      num >>>= 0;
      var b = num & 0xff,
        g = (num & 0xff00) >>> 8,
        r = (num & 0xff0000) >>> 16,
        a = ((num & 0xff000000) >>> 24) / 255;

      //if (type == 1){
      //  a = 0.1 -a/10
      //}

      return "rgba(" + [r, g, b, a].join(",") + ")";
    },
    beginLine(event) {
      if (event.button == 0) {
        //left button
        this.showPenMarkerOption = false;
        this.drawing = true;
        var rect = this.$refs.drawingArea.getBoundingClientRect();

        this.ctx.beginPath();

        switch (this.usingTool) {
          case 0: //pen
            this.ctx.strokeStyle = this.toColor(
              parseInt("0xFF" + this.penLineColor, 16),
              0
            );
            this.ctx.lineWidth = this.penStrokeWidth;
            this.newLayer = {
              timestamp: new Date() / 1,
              type: "PDFToolType.pen",
              percentOffsets: [],
              strokeWidthPercent: this.penStrokeWidth * this.percentOffsetRadio,
              color: parseInt("0xFF" + this.penLineColor, 16),
            };
            break;

          case 1: //marker
            this.ctx.strokeStyle = this.toColor(
              parseInt("0x10" + this.markerLineColor, 16),
              1
            );
            this.ctx.lineWidth = this.markerStrokeWidth;
            this.newLayer = {
              timestamp: new Date() / 1,
              type: "PDFToolType.highlight",
              percentOffsets: [],
              strokeWidthPercent:
                this.markerStrokeWidth * this.percentOffsetRadio,
              color: parseInt("0x10" + this.markerLineColor, 16),
            };
            break;

          case 2:
            this.eraserPosition = [];
            this.ctx.strokeStyle = this.toColor(parseInt("0xFFFFFFFF", 16), 0);
            this.ctx.lineWidth = 16;
            break;
        }

        if (this.usingTool == 0 || this.usingTool == 1)
          this.newLayer.percentOffsets.push(
            (event.clientX - rect.left) * this.percentOffsetRadio +
              "," +
              (event.clientY - rect.top) * this.percentOffsetRadio
          );
        else
          this.eraserPosition.push({
            x: Math.round(
              (event.clientX - rect.left) * this.percentOffsetRadio
            ),
            y: Math.round((event.clientY - rect.top) * this.percentOffsetRadio),
          });
        this.ctx.moveTo(event.clientX - rect.left, event.clientY - rect.top);
      }
    },
    drawLine(event) {
      if (this.drawing && event.button == 0) {
        var rect = this.$refs.drawingArea.getBoundingClientRect();

        this.ctx.lineTo(event.clientX - rect.left, event.clientY - rect.top);
        this.ctx.stroke();

        if (this.usingTool == 0 || this.usingTool == 1)
          this.newLayer.percentOffsets.push(
            (event.clientX - rect.left) * this.percentOffsetRadio +
              "," +
              (event.clientY - rect.top) * this.percentOffsetRadio
          );
        else
          this.eraserPosition.push({
            x: Math.round(
              (event.clientX - rect.left) * this.percentOffsetRadio
            ),
            y: Math.round((event.clientY - rect.top) * this.percentOffsetRadio),
          });
      }
    },
    endLine(event) {
      if (this.drawing && event.button == 0) {
        var rect = this.$refs.drawingArea.getBoundingClientRect();
        this.drawing = false;

        if (this.pdfDrawing.pages[this.page] === undefined) {
          this.pdfDrawing.pages[this.page] = { layers: [] };
        }

        if (this.usingTool == 0 || this.usingTool == 1) {
          this.newLayer.percentOffsets.push(
            (event.clientX - rect.left) * this.percentOffsetRadio +
              "," +
              (event.clientY - rect.top) * this.percentOffsetRadio
          );
          this.pdfDrawing.pages[this.page].layers.push(this.newLayer);
          this.pdfDrawing.lastEdited = new Date() / 1;
        }

        if (this.usingTool == 2) {
          this.reLineIndex();

          for (var i = 0; i < this.eraserPosition.length; i++) {
            var x = this.eraserPosition[i].x;
            var y = this.eraserPosition[i].y;
            if (this.lineIndex[x] != undefined) {
              if (this.lineIndex[x][y] != undefined) {
                for (var j = 0; j < this.lineIndex[x][y].length; j++) {
                  delete this.pdfDrawing.pages[this.page].layers[
                    this.lineIndex[x][y][j]
                  ];
                }
              }
            }
          }
          this.drawPDFNote();
        }
      }
    },
    reLineIndex() {
      this.lineIndex = [];
      for (const [key, value] of Object.entries(
        this.pdfDrawing.pages[this.page].layers
      )) {
        for (var i = 0; i < value.percentOffsets.length; i++) {
          var point = value.percentOffsets[i].split(",");

          if (this.lineIndex[Math.round(point[0])] == undefined)
            this.lineIndex[Math.round(point[0])] = [];

          if (
            this.lineIndex[Math.round(point[0])][Math.round(point[1])] ==
            undefined
          )
            this.lineIndex[Math.round(point[0])][Math.round(point[1])] = [];

          if (
            !this.lineIndex[Math.round(point[0])][
              Math.round(point[1])
            ].includes(key)
          )
            this.lineIndex[Math.round(point[0])][Math.round(point[1])].push(
              key
            );
        }
      }
    },
    onWindowResize() {
      this.drawPDFNote();
    },
    onPdfResize() {
      this.drawPDFNote();
    },
    onDebug() {
      console.log("test");
    },
    saveDrawing() {
      this.showPenMarkerOption = false;
      this.$store.dispatch("sendDrawing");
    },
    previousPage() {
      this.showPenMarkerOption = false;
      if (this.page - 1 > 0) this.page = this.page - 1;
    },
    nextPage() {
      this.showPenMarkerOption = false;
      if (this.page + 1 <= this.pageCount) this.page = this.page + 1;
    },
    undoDrawing() {
      this.showPenMarkerOption = false;
      this.pdfDrawing.pages[this.page].layers.pop();
      this.drawPDFNote();
    },
    changePage() {
      if (
        this.showingPageNumber > 0 &&
        this.showingPageNumber <= this.pageCount
      ) {
        this.page = parseInt(this.showingPageNumber);
      }
    },
    changeColor(color) {
      if (this.usingTool == 0) {
        this.penLineColor = color;
      } else {
        this.markerLineColor = color;
      }
    },
    changeSize(size) {
      if (this.usingTool == 0) {
        this.penStrokeWidth = 15 - 1 * size;
      } else {
        this.markerStrokeWidth = 15 - 1 * size;
      }
    },
    usePen() {
      this.toolOptionLeft = 50;
      if (this.usingTool == 0) {
        this.showPenMarkerOption = !this.showPenMarkerOption;
      } else {
        this.usingTool = 0;
        this.showPenMarkerOption = true;
      }
    },
    useMarker() {
      this.toolOptionLeft = 90;
      if (this.usingTool == 1) {
        this.showPenMarkerOption = !this.showPenMarkerOption;
        console.log(this.showPenMarkerOption);
      } else {
        this.usingTool = 1;
        this.showPenMarkerOption = true;
      }
    },
    useEraser() {
      this.usingTool = 2;
      this.showPenMarkerOption = false;
    },
  },
};
</script>

<style scoped>
.colorPicker {
  width: 30px;
  height: 30px;
  border: 1px solid #cfcfcf;
  cursor: pointer;
}

.sizePicker {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 14px solid #ffffff;
  background-color: #555555;
  cursor: pointer;
}

.customToolBar {
  width: 100%;
  min-height: 45px;
  background: #313131;
  border-radius: 15px 15px 0px 0px;
  padding: 0px 20px 0px 20px;
  font-size: 16px;
  color: #ffffff;
}

.customPageNumber {
  min-width: 55px;
  max-width: 55px;
  padding: 0px 0px 0px 10px;
  margin: 0px 0px 0px 0px;
  height: 30px;
  background-color: #ffffff;
}

.customDivOneLine {
  display: flex;
  white-space: nowrap;
  align-items: center;
  width: 100%;
  padding: 0px 0px 0px 0px;
}
.customLeftToolbar {
  display: inline-flex;
  white-space: nowrap;
  align-items: center;
  padding: 5px 0px 5px 0px;
}

.customRightToolbar {
  display: inline-flex;
  white-space: nowrap;
  align-items: center;
  padding: 5px 0px 5px 0px;
}

.customDivider {
  width: 100%;
  height: 1px;
  background-color: #4a4a4a;
  margin-top: 15px;
}

.customDividerOption {
  width: 100%;
  height: 1px;
  background-color: #f2f2f2;
  margin-top: 15px;
}
</style>

<style scoped lang="scss">
</style>